module.exports = __webpack_public_path__ + "img/a13.625245d7.jpg";